{
	"version": 1,
	"presets": [
		{
			"id": "square",
			"label": ["Square", "方形"],
			"width": 1080,
			"height": 1080
		},
		{
			"id": "portrait",
			"label": ["Portrait card", "竖版卡片"],
			"width": 1080,
			"height": 1440
		},
		{
			"id": "vertical",
			"label": ["Vertical video", "竖屏视频"],
			"width": 1080,
			"height": 1920
		},
		{
			"id": "landscape",
			"label": ["Landscape", "横版"],
			"width": 1920,
			"height": 1080
		}
	],
	"card": {
		"background": "#f7f6f2",
		"foreground": "#252525",
		"secondary": "#656560",
		"padding": 88,
		"title_size": 62,
		"body_size": 42,
		"line_height": 66
	},
	"limits": {
		"max_file_bytes": 26214400,
		"max_brand_bytes": 536870912,
		"max_panels": 20,
		"max_video_seconds": 300
	},
	"formats": {
		"text": {
			"encoding": "utf-8"
		},
		"image": {
			"mime": "image/png",
			"fit": "contain"
		},
		"video": {
			"mime": "video/mp4",
			"codec": "h264",
			"pixel_format": "yuv420p",
			"fps": 24
		},
		"audio": {
			"mime": "audio/mpeg"
		},
		"subtitle": {
			"mime": "text/vtt"
		}
	}
}
